import React, { useState, useEffect, Component } from 'react'
import { Button, Message, Panel, Table } from 'rsuite'
import { useForm, Controller } from 'react-hook-form'
import { budgetFormat } from '../../utils/formatterUtil'
import { getDowloadSubProjectFilePath } from '../../redux/actions/subProjectFinancialReport'
import { doneLoading, startLoading } from '../../utils/loading'
import OverlayLoader from '../../components/OverlayLoader/OverlayLoader'
import { DEFAULT_ERR_MSG } from '../../constants/msgText'
import { downloadFile } from '../../utils/fileUtil'
import notification from '../../utils/notification'

export default function InstallmentReportWidget(props) {
  const { register, handleSubmit, errors, control, getValues, setValue, setError, clearErrors } =
    useForm()
  const { Column, HeaderCell, Cell, Pagination } = Table
  const [formSchema, setFormSchema] = useState(props.schema)
  const [isLoading, setIsLoading] = useState(false)
  const [isErrors, setIsErrors] = useState()

  // const viewFiles = async (dataRow) => {
  //   console.log('vieeeeeeee', dataRow)
  //   setIsLoading(true)
  //   if (!dataRow.linkTo) {
  //     setIsErrors(DEFAULT_ERR_MSG)
  //     doneLoading()
  //     setIsLoading(false)
  //     return false
  //   }

  //   startLoading()
  //   var file = await getDowloadSubProjectFilePath(dataRow.linkTo)
  //   const url = window.URL.createObjectURL(new Blob([file], { type: file.type }))
  //   const link = document.createElement('a')
  //   link.href = url
  //   link.target = '_blank'
  //   link.setAttribute('value', dataRow.text)
  //   document.body.appendChild(link)
  //   link.click()
  //   doneLoading()

  //   setIsLoading(false)
  // }

  const viewFiles = async (dataRow) => {
    console.log('datarow => ', dataRow)
    // return false
    startLoading()
    try {
      const file = await getDowloadSubProjectFilePath(dataRow.linkTo)
      downloadFile(file, dataRow.text)
    } catch (err) {
      console.log('errr => ', err)
      notification.open('error', {
        title: 'ดาวน์โหลดเอกสารไม่สำเร็จ',
      })
    }
    doneLoading()
  }

  return (
    <>
      <Panel shaded header={formSchema.title} collapsible defaultExpanded>
        {isLoading && <OverlayLoader />}

        {isErrors && (
          <Message
            type="error"
            description={isErrors}
            style={{ marginBottom: 10, marginTop: 10 }}
          />
        )}

        <table width={'100%'} border={1}>
          <thead>
            <tr>
              <th width={'10%'}>
                <div style={{ padding: 8, marginTop: 5 }}>งวดที่</div>
              </th>
              <th width={'25%'}>
                <div style={{ padding: 8, marginTop: 5 }}>ระยะเวลา</div>
              </th>
              <th width={'15%'}>
                <div style={{ padding: 8, marginTop: 5 }}>งบประมาณ</div>
              </th>
              <th width={'15%'}>
                <div style={{ padding: 8, marginTop: 5 }}>สถานะ</div>
              </th>
              <th width={'10%'}>
                <div style={{ padding: 8, marginTop: 5 }}>วันที่เบิกจ่าย</div>
              </th>
              <th width={'25%'}>
                <div style={{ padding: 8, marginTop: 5 }}>รายงาน</div>
              </th>
            </tr>
          </thead>
          <tbody>
            {formSchema.values.map((item, index) => {
              return (
                <tr key={index}>
                  <td align="center" style={{ verticalAlign: 'top' }}>
                    <div style={{ padding: 5, marginTop: 5 }}>{item?.period || ''}</div>
                  </td>
                  <td align="center" style={{ verticalAlign: 'top' }}>
                    <div style={{ padding: 5, marginTop: 5 }}>{item?.longTerm || ''}</div>
                  </td>
                  <td align="right" style={{ verticalAlign: 'top' }}>
                    <div style={{ padding: 5, marginTop: 5 }}>
                      {budgetFormat(item?.budget || 0)}
                    </div>
                  </td>
                  <td align="center" style={{ verticalAlign: 'top' }}>
                    <div style={{ padding: 5, marginTop: 5 }}>{item?.statusTxt || ''}</div>
                  </td>
                  <td align="center" style={{ verticalAlign: 'top' }}>
                    <div style={{ padding: 5, marginTop: 5 }}>{item?.disbursementDate || ''}</div>
                  </td>
                  <td>
                    <div>
                      {item.report &&
                        item.report.length > 0 &&
                        item.report.map((i, index) => {
                          return (
                            <>
                              <Button
                                appearance="link"
                                disabled={!i.linkTo}
                                key={index}
                                onClick={() => {
                                  setIsErrors(null)
                                  viewFiles(i)
                                }}
                              >{`${index + 1}. ${i.text}`}</Button>
                              <br />
                            </>
                          )
                        })}
                    </div>
                  </td>
                </tr>
              )
            })}
          </tbody>
        </table>

        {/* <Table autoHeight data={formSchema.values} rowHeight={100}>
          <Column width={100} align="center">
            <HeaderCell>งวดที่</HeaderCell>
            <Cell dataKey="period" />
          </Column>

          <Column flexGrow={1} align="center">
            <HeaderCell>ระยะเวลา</HeaderCell>
            <Cell dataKey="longTerm" />
          </Column>

          <Column width={200} align="right">
            <HeaderCell>งบประมาณ</HeaderCell>
            <Cell>
              {(rowData) => {
                return budgetFormat(rowData.budget || 0)
              }}
            </Cell>
          </Column>

          <Column width={150} align="center">
            <HeaderCell>สถานะ</HeaderCell>
            <Cell dataKey="statusTxt" />
          </Column>

          <Column width={150} align="center">
            <HeaderCell>วันที่เบิกจ่าย</HeaderCell>
            <Cell dataKey="disbursementDate" />
          </Column>

          <Column width={350}>
            <HeaderCell>รายงาน</HeaderCell>
            <Cell>
              {(rowData) => {
                if (rowData?.report?.length > 0) {
                  let str = ''
                  rowData.report.map((item, index) => {
                    str += `<a href="https://www.google.com/" target="_blank">${item.text}</a><br />`
                  })

                  return <div dangerouslySetInnerHTML={{ __html: str }} />
                }

                return ''
              }}
            </Cell>
          </Column>
        </Table> */}
      </Panel>
    </>
  )
}
